import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { InfoWindow } from 'google-maps-react';
import { markerDataUpdated } from '../redux/actions/markerData';

const InfoWindowEx = props => {
  const infoWindowRef = React.createRef();
  const contentElement = document.createElement(`div`);
  const markerDataState = useSelector(state => state.markerData);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(markerDataUpdated({
      ...markerDataState,
      showTooltip: false,
      activeMarker: null,
      activeResult: null
    }))
  }

  useEffect(() => {
    if(!markerDataState.showTooltip) {
      handleClose()
    }
  }, [markerDataState.showTooltip])

  useEffect(() => {
    ReactDOM.render(React.Children.only(props.children), contentElement);
    infoWindowRef.current.infowindow.setContent(contentElement);
  }, [props.children]);
  
  return <InfoWindow onClose={handleClose} ref={infoWindowRef} visible={markerDataState.showTooltip} {...props} />;
};

export default InfoWindowEx;